import { SenderRole, type UIMessage } from '../types/chat-model'
import { Markdown } from './markdown'
import { MessageChoices } from './message-choices'

interface TextMessageRenderProps {
  message: UIMessage
  isLatest?: boolean
}

export default function TextMessageRender({ message, isLatest }: TextMessageRenderProps) {
  const content = message.content
  const choices = message.choices

  return (
    /* 总容器 */
    <div className='flex w-full min-w-0 flex-col overflow-hidden'>
      {/* 实际消息 */}
      <div className='w-full min-w-0 overflow-hidden'>
        <Markdown>{content}</Markdown>
      </div>

      {/* 选项区域 */}
      {isLatest && message.role === SenderRole.AUTHOR && (
        <MessageChoices choices={choices || []} mode="chat" className="mt-8" />
      )}
    </div>
  )
}
